import { watchGetDataDashboard, watchGetDataDashboard2, watchGetDataDashboard3, watchGetDataDashboard4, watchGetDataDashboard5, watchGetDataDashboard6, watchGetDataPlanDashboard, watchGetDataPlanNextWeekDashboard, watchGetDataPlanTimeExtendtionDashboard } from "./dashboardSaga";
import { call, all } from 'redux-saga/effects';
//IndexImportHygen
export default function* rootDashboardSaga() {
    yield all([
      call(watchGetDataDashboard),
      call(watchGetDataDashboard2),
      call(watchGetDataDashboard3),
      call(watchGetDataDashboard4),
      call(watchGetDataDashboard5),
      call(watchGetDataDashboard6),
      call(watchGetDataPlanDashboard),
      call(watchGetDataPlanNextWeekDashboard),
      call(watchGetDataPlanTimeExtendtionDashboard),
      //IndexUsingHygen
      ])
  }